module.exports = __webpack_public_path__ + "static/media/recurVer.e414283e.png";